module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAWQAAAFkBqp2phgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADRSURBVDiNxZM7CsJQEEVPfiiKBLTxBzYGC3eQVQi2lq4gW7K3cAUWbkAiuAKJIIoahJjfs4iIRdCYFN5yhnuY4c5IQgiKSC7kBqSlOZwA/Zz+jQrM3itKRaHaq3DdulkA3muFcrMEgAgF/jnIOoEkAzTMOobVpztuQyzwHI/OqPXsfpYK4B/vaLoGQBwmqewWDsTfATKAt/dZWzaH1enV+GmC4JLsHN0iNF2jNqiymzvf3aTcQegGWRNIB4gYQjfKD/hVRQFCBaaAkRNgS3//xgfcDEFNqP4avQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-china.png
// module id = J2Xs
// module chunks = 29